export default __webpack_public_path__ + "static/media/atore_3.c055bbd8.png";